import {
  Type,
  AlignLeft,
  List,
  CheckSquare,
  Circle,
  Calendar,
  Upload,
  Hash,
  Mail,
  Phone,
  Link,
  Heading,
  FileText,
  SlidersHorizontal,
  BarChart3,
  Star,
  Image,
  ToggleLeft,
  MessageSquare,
  Sparkles,
  PartyPopper,
  ExternalLink,
} from 'lucide-react';
import type { FormField, FieldType } from '../types/forms';

// Paleta de campos disponíveis (6 categorias temáticas — Story 4.1)
export const FIELD_PALETTE = [
  // contact_info
  { type: 'email' as FieldType, label: 'Email', icon: Mail, category: 'contact_info' },
  { type: 'phone' as FieldType, label: 'Telefone', icon: Phone, category: 'contact_info' },
  { type: 'url' as FieldType, label: 'URL', icon: Link, category: 'contact_info' },
  // text_media
  { type: 'text' as FieldType, label: 'Texto curto', icon: Type, category: 'text_media' },
  { type: 'textarea' as FieldType, label: 'Texto longo', icon: AlignLeft, category: 'text_media' },
  { type: 'file' as FieldType, label: 'Upload de arquivo', icon: Upload, category: 'text_media' },
  // choice
  { type: 'select' as FieldType, label: 'Lista suspensa', icon: List, category: 'choice' },
  { type: 'checkbox' as FieldType, label: 'Múltipla escolha', icon: CheckSquare, category: 'choice' },
  { type: 'radio' as FieldType, label: 'Escolha única', icon: Circle, category: 'choice' },
  { type: 'picture_choice' as FieldType, label: 'Escolha com imagem', icon: Image, category: 'choice' },
  { type: 'yes_no' as FieldType, label: 'Sim / Não', icon: ToggleLeft, category: 'choice' },
  // rating_ranking
  { type: 'opinion_scale' as FieldType, label: 'Escala de opinião', icon: SlidersHorizontal, category: 'rating_ranking' },
  { type: 'nps' as FieldType, label: 'NPS', icon: BarChart3, category: 'rating_ranking' },
  { type: 'rating' as FieldType, label: 'Avaliação', icon: Star, category: 'rating_ranking' },
  // other
  { type: 'number' as FieldType, label: 'Número', icon: Hash, category: 'other' },
  { type: 'date' as FieldType, label: 'Data', icon: Calendar, category: 'other' },
  { type: 'datetime' as FieldType, label: 'Data e hora', icon: Calendar, category: 'other' },
  // layout
  { type: 'heading' as FieldType, label: 'Título', icon: Heading, category: 'layout' },
  { type: 'paragraph' as FieldType, label: 'Parágrafo', icon: FileText, category: 'layout' },
  { type: 'statement' as FieldType, label: 'Declaração', icon: MessageSquare, category: 'layout' },
  { type: 'welcome_screen' as FieldType, label: 'Tela de boas-vindas', icon: Sparkles, category: 'layout' },
  { type: 'thank_you_screen' as FieldType, label: 'Tela de obrigado', icon: PartyPopper, category: 'layout' },
  { type: 'redirect_url' as FieldType, label: 'Redirecionar para URL', icon: ExternalLink, category: 'layout' },
];

// Gerar ID único
export const generateId = () => `field_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

// Criar campo padrão
export const createDefaultField = (type: FieldType): FormField => {
  const base: FormField = {
    id: generateId(),
    type,
    label: FIELD_PALETTE.find(f => f.type === type)?.label || 'Novo campo',
    placeholder: '',
    required: false,
    options: ['select', 'checkbox', 'radio', 'multiselect'].includes(type) ? ['Opção 1', 'Opção 2'] : undefined,
  };

  // Default configs for new field types
  switch (type) {
    case 'opinion_scale':
      base.config = { minValue: 1, maxValue: 10, minLabel: 'Discordo totalmente', maxLabel: 'Concordo totalmente' };
      break;
    case 'rating':
      base.config = { maxRating: 5, iconType: 'star' };
      break;
    case 'picture_choice':
      base.config = { images: [], multiSelect: false };
      break;
    case 'welcome_screen':
      base.config = { buttonText: 'Começar', showDescription: true };
      base.required = false;
      break;
    case 'thank_you_screen':
      base.config = { showShareButton: false, redirectDelay: 0 };
      base.required = false;
      break;
    case 'redirect_url':
      base.config = { url: '', delay: 0, openInNewTab: false, hideCountdown: true };
      base.label = 'Redirecionar para URL';
      base.required = false;
      break;
  }

  return base;
};
